const MENU_KEYS = {
    OVERVIEW: "overview",
    AUDIENCE: "audience",
    PERFORMANCE: "performance",
    CAMPAIGNS: "campaigns",
    ADSETS: "adsets",
    ADS: "ads",
    DETAIL: "detail",
    VISIBILITY: "visibility",
};

/**
 * SidebarChild ile uyumlu menu items (key/label/icon/group/enabled).
 * @param {Object} that - parent component (translation icin $t kullanir)
 * @returns {Array}
 */
const Items = (that) => {
    const t = (k, fb) => (that && that.$t ? that.$t(k) : fb);
    const reportsGroup = t("metaInsights.reports_group", "Reports");
    const settingsGroup = t("metaInsights.settings_group", "Settings");
    return [
        {
            enabled: true,
            key: MENU_KEYS.OVERVIEW,
            label: t("metaInsights.overview", "Overview"),
            icon: { type: "material-icons", name: "dashboard" },
            group: reportsGroup,
        },
        {
            enabled: true,
            key: MENU_KEYS.AUDIENCE,
            label: t("metaInsights.audience", "Audience"),
            icon: { type: "material-icons", name: "groups" },
            group: reportsGroup,
        },
        {
            enabled: true,
            key: MENU_KEYS.PERFORMANCE,
            label: t("metaInsights.performance", "Performance"),
            icon: { type: "material-icons", name: "insights" },
            group: reportsGroup,
        },
        {
            enabled: true,
            key: MENU_KEYS.CAMPAIGNS,
            label: t("metaInsights.campaigns", "Campaigns"),
            icon: { type: "material-icons", name: "campaign" },
            group: reportsGroup,
        },
        {
            enabled: true,
            key: MENU_KEYS.ADSETS,
            label: t("metaInsights.adSets", "Ad Sets"),
            icon: { type: "material-icons", name: "view_module" },
            group: reportsGroup,
        },
        {
            enabled: true,
            key: MENU_KEYS.ADS,
            label: t("metaInsights.ads", "Ads"),
            icon: { type: "material-icons", name: "ads_click" },
            group: reportsGroup,
        },
        {
            enabled: true,
            key: MENU_KEYS.DETAIL,
            label: t("metaInsights.detail", "Detail"),
            icon: { type: "material-icons", name: "info" },
            group: settingsGroup,
        },
        {
            enabled: true,
            key: MENU_KEYS.VISIBILITY,
            label: t("metaInsights.visibility", "Visibility"),
            icon: { type: "material-icons", name: "visibility" },
            group: settingsGroup,
        },
    ];
};

export default {
    MENU_KEYS,
    Items,
};
